export default "__VITE_ASSET__zCSK7rLX__"